import React from 'react';
import {Field, formValueSelector, change} from 'redux-form';
import {connect} from 'react-redux';
import ReCaptcha from 'react-gcaptcha';

const reset = (props) => {
    if (props.meta.submitting) {
        props.meta.dispatch(change('gratisForm', 'g-recaptcha-response', null));
        return true;
    }
    return false;
};
const expired = (props) => () => {
    if (props && props.meta && props.meta.dispatch) {
        props.meta.dispatch(change('gratisForm', 'g-recaptcha-response', null));
    }
    return;
};
const Captcha = (props) => (
    <div>
        <ReCaptcha
            sitekey={props['data-sitekey']}
            reset={reset(props)}
            verifyCallback={props.input.onChange}
            expiredCallback={expired(props)}
        />
    </div>
);

class Submit extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.visible) return null;
        const {office, product, contactForm } = this.props;
        const style = this.props.errorStyle;
        return (
            <fieldset id="submitFields">
                {!contactForm && !product.onlinefulfillment &&
                <legend>Inspection Copy Agreement</legend>
                }
                <div className="gratisRequestInstructions">
                    {!contactForm && !product.onlinefulfillment &&
                    <div>
                        <div className="paragraph"
                             dangerouslySetInnerHTML={{__html: office.config.studentTerms}}>
                        </div>
                        <div className="paragraph">
                            <div dangerouslySetInnerHTML={{__html: office.config.instructorTerms}}/>
                        </div>
                        <div id="agreeToTermsContainer">
                            {(office.config.instructorTerms || office.config.studentTerms) &&
                            <div className="paragraph">
                                <Field style={style('termsAndConditions').input} type="checkbox" component="input"
                                       name="termsAndConditions"/> <b style={style('termsAndConditions').label}>I
                                understand and agree to the terms of the agreement above.</b>
                            </div>
                            }
                            {office.config.marketingPrefs && office.config.marketingPrefs.email &&
                            <div className="paragraph">
                                <Field type="checkbox" component="input" name="marketingEmail"/>
                                <b dangerouslySetInnerHTML={{__html: office.config.marketingPrefs.email.message}}></b>
                            </div>
                            }
                            {office.config.marketingPrefs && office.config.marketingPrefs.post &&
                            <div className="paragraph">
                                <Field type="checkbox" component="input" name="marketingPost"/>
                                <b dangerouslySetInnerHTML={{__html: office.config.marketingPrefs.post.message}}></b>
                            </div>
                            }
                        </div>
                    </div>
                    }
                    <div>
                        <Field name="recaptcha_client" value="gratis_web_form" component="input" type="hidden"/>
                        <Field name="g-recaptcha-response" component={Captcha}
                               data-reset={this.props}
                               data-sitekey={this.props.options.recaptcha.siteKey}/>
                    </div>
                    <div dangerouslySetInnerHTML={{__html: office.config.privacyPolicyMessage}}>
                    </div>
                    <div id="submitButtonContainer">
                        <input id="bookRequestSubmitButton" type="submit"
                               disabled={this.props.captchaResponse == null}
                               value="Submit Request"/>
                    </div>
                </div>
            </fieldset>
        );
    }
}

const selector = formValueSelector('gratisForm'); // XXX: hardcoded form name!

export default connect(state => ({
    ...state,
    captchaResponse: selector(state, 'g-recaptcha-response')
}))(Submit);




// WEBPACK FOOTER //
// ./src/form/components/Submit.jsx